import React from 'react';

import CollapsibleWrapper from '~/components/core/Collapsible/CollapsibleWrapper';
import VoiceMessageConfigurationDialog from '~/components/SystemConfiguration/Communications/PhoneConfigurationTab/VoiceMessageConfigurationDialog/VoiceMessageConfigurationDialog';
import type { PhoneSurveyConfigurationModelVoiceMessageConfigurationParams } from '~/server_shared/openapi/data-contracts';

interface VoiceMessageConfigurationSectionProps {
  title: string;
  subtitle?: string;
  voiceMessageConfiguration: PhoneSurveyConfigurationModelVoiceMessageConfigurationParams;
  radioButtonGroupId: string;
  textAreaId: string;
  voiceFileInputId: string;
  onReplaceExistingRecording: () => void;
  actions?: React.ReactNode;
  storedFileIdPath?: string;
  children?: React.ReactNode;
}

const VoiceMessageConfigurationSection: React.FC<VoiceMessageConfigurationSectionProps> = ({
  title,
  subtitle,
  voiceMessageConfiguration,
  radioButtonGroupId,
  textAreaId,
  voiceFileInputId,
  onReplaceExistingRecording,
  actions,
  storedFileIdPath,
  children,
}) => {
  return (
    <CollapsibleWrapper
      title={title}
      subtitle={subtitle}
      defaultState={false}
      backgroundColor={CollapsibleWrapper.BACKGROUND_COLOR.WHITE}
      actionCard
      noDivider
      unmountOnExit={false}
      actions={actions}
    >
      <VoiceMessageConfigurationDialog
        voiceMessageConfiguration={voiceMessageConfiguration}
        radioButtonGroupId={radioButtonGroupId}
        textAreaId={textAreaId}
        voiceFileInputId={voiceFileInputId}
        onReplaceExistingRecording={onReplaceExistingRecording}
        storedFileIdPath={storedFileIdPath}
      />
      {children}
    </CollapsibleWrapper>
  );
};

export default VoiceMessageConfigurationSection;
